import React from 'react';
import Layout from '../components/Layout/Layout';
import parPdf from '../images/par-section.pdf';

const PARProfilePage = () => {
  return (
    <Layout>
      <div id="par-profile" className="page-container" style={{ maxWidth: '800px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '400px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
          PAR Detail Report
        </h2>
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', textAlign: 'center' }}>
          <p style={{ color: '#555', marginBottom: '20px' }}>View the full Performance Appraisal Report document below.</p>
          <iframe src={parPdf} width="100%" height="800px" title="PAR Profile" style={{ border: 'none', backgroundColor: '#f0f0f0' }} />
        </div>
      </div>
    </Layout>
  );
};

export default PARProfilePage;
